export enum ThemeName {
  Light = 'light',
  Dark = 'dark',
}

export type RemoveSuffix<T, S extends string> = T extends `${infer P}${S}` ? P : T
